import * as Types from '../../../../gql/__generated/graphql.types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type DmaTasksQueryVariables = Types.Exact<{
  sceneId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  surfaceId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  lvl1?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  lvl2?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  brand?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  primaryColorFamilyLabel?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  skus?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  lastSeenId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.TaskOrderBy>;
}>;


export type DmaTasksQuery = (
  { __typename?: 'Query' }
  & { GetTasks?: Types.Maybe<(
    { __typename?: 'TasksQueryResult' }
    & Pick<Types.TasksQueryResult, 'last_seen_id' | 'count' | 'total'>
    & { results?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'Task' }
      & Pick<Types.Task, 'id' | 'sku' | 'material_id' | 'scene_id' | 'layout_id' | 'surface_id' | 'lighting' | 'published' | 'title' | 'image_rendering' | 'image_preview' | 'surface_name' | 'has_layouts' | 'lvl0' | 'lvl1' | 'lvl2' | 'brand' | 'primary_color_family_label' | 'price'>
    )>>>, facets?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'TaskFacetResultValue' }
      & Pick<Types.TaskFacetResultValue, 'facet_name' | 'facet_value' | 'facet_count'>
    )>>> }
  )> }
);

export type DmaTasksWithLayerQueryVariables = Types.Exact<{
  sceneId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  surfaceId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  lvl1?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  lvl2?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  brand?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  primaryColorFamilyLabel?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  skus?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  lastSeenId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.TaskOrderBy>;
}>;


export type DmaTasksWithLayerQuery = (
  { __typename?: 'Query' }
  & { GetTasksWithLayer?: Types.Maybe<(
    { __typename?: 'TasksWithLayerQueryResult' }
    & Pick<Types.TasksWithLayerQueryResult, 'last_seen_id' | 'count' | 'total'>
    & { results?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'TaskWithLayer' }
      & Pick<Types.TaskWithLayer, 'id' | 'sku' | 'material_id' | 'scene_id' | 'layout_id' | 'surface_id' | 'lighting' | 'published' | 'title' | 'image_rendering' | 'image_preview' | 'surface_name' | 'has_layouts' | 'lvl0' | 'lvl1' | 'lvl2' | 'brand' | 'primary_color_family_label' | 'price' | 'layer_level'>
    )>>>, facets?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'TaskFacetResultValue' }
      & Pick<Types.TaskFacetResultValue, 'facet_name' | 'facet_value' | 'facet_count'>
    )>>> }
  )> }
);



export const DmaTasksDocument = `
    query DmaTasks($sceneId: Int, $surfaceId: Int, $lvl1: [String], $lvl2: [String], $brand: [String], $primaryColorFamilyLabel: [String], $skus: [String], $lastSeenId: String, $limit: Int, $orderBy: TaskOrderBy) {
  GetTasks(
    scene_id: $sceneId
    surface_id: $surfaceId
    lvl1: $lvl1
    lvl2: $lvl2
    brand: $brand
    primary_color_family_label: $primaryColorFamilyLabel
    skus: $skus
    last_seen_id: $lastSeenId
    limit: $limit
    orderBy: $orderBy
  ) {
    last_seen_id
    count
    total
    results {
      id
      sku
      material_id
      scene_id
      layout_id
      surface_id
      lighting
      published
      title
      image_rendering
      image_preview
      surface_name
      has_layouts
      lvl0
      lvl1
      lvl2
      brand
      primary_color_family_label
      price
    }
    facets {
      facet_name
      facet_value
      facet_count
    }
  }
}
    `;

export const useDmaTasksQuery = <
      TData = DmaTasksQuery,
      TError = unknown
    >(
      variables?: DmaTasksQueryVariables,
      options?: Omit<UseQueryOptions<DmaTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DmaTasksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DmaTasksQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DmaTasks'] : ['DmaTasks', variables],
    queryFn: graphqlFetcher<DmaTasksQuery, DmaTasksQueryVariables>(DmaTasksDocument, variables),
    ...options
  }
    )};

useDmaTasksQuery.getKey = (variables?: DmaTasksQueryVariables) => variables === undefined ? ['DmaTasks'] : ['DmaTasks', variables];


useDmaTasksQuery.fetcher = (variables?: DmaTasksQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<DmaTasksQuery, DmaTasksQueryVariables>(DmaTasksDocument, variables, options);

export const DmaTasksWithLayerDocument = `
    query DmaTasksWithLayer($sceneId: Int, $surfaceId: Int, $lvl1: [String], $lvl2: [String], $brand: [String], $primaryColorFamilyLabel: [String], $skus: [String], $lastSeenId: String, $limit: Int, $orderBy: TaskOrderBy) {
  GetTasksWithLayer(
    scene_id: $sceneId
    surface_id: $surfaceId
    lvl1: $lvl1
    lvl2: $lvl2
    brand: $brand
    primary_color_family_label: $primaryColorFamilyLabel
    skus: $skus
    last_seen_id: $lastSeenId
    limit: $limit
    orderBy: $orderBy
  ) {
    last_seen_id
    count
    total
    results {
      id
      sku
      material_id
      scene_id
      layout_id
      surface_id
      lighting
      published
      title
      image_rendering
      image_preview
      surface_name
      has_layouts
      lvl0
      lvl1
      lvl2
      brand
      primary_color_family_label
      price
      layer_level
    }
    facets {
      facet_name
      facet_value
      facet_count
    }
  }
}
    `;

export const useDmaTasksWithLayerQuery = <
      TData = DmaTasksWithLayerQuery,
      TError = unknown
    >(
      variables?: DmaTasksWithLayerQueryVariables,
      options?: Omit<UseQueryOptions<DmaTasksWithLayerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DmaTasksWithLayerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DmaTasksWithLayerQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DmaTasksWithLayer'] : ['DmaTasksWithLayer', variables],
    queryFn: graphqlFetcher<DmaTasksWithLayerQuery, DmaTasksWithLayerQueryVariables>(DmaTasksWithLayerDocument, variables),
    ...options
  }
    )};

useDmaTasksWithLayerQuery.getKey = (variables?: DmaTasksWithLayerQueryVariables) => variables === undefined ? ['DmaTasksWithLayer'] : ['DmaTasksWithLayer', variables];


useDmaTasksWithLayerQuery.fetcher = (variables?: DmaTasksWithLayerQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<DmaTasksWithLayerQuery, DmaTasksWithLayerQueryVariables>(DmaTasksWithLayerDocument, variables, options);
